export default __webpack_public_path__ + "static/media/ivanv_l.964edbe2.jpg";